package com.essntl.features.itinerary.ui.edit_itinerary_service.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import com.essntl.features.address.ui.AddressEvent
import com.essntl.features.address.ui.AddressState
import com.essntl.features.address.ui.AddressValidation
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.ContactValidation
import com.essntl.features.contact.ui.contactdetails.ContactDetailsScreen
import com.essntl.features.customfields.ui.CustomFieldsEvent
import com.essntl.features.customfields.ui.CustomFieldsState
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.organization.ui.OrganizationEvent
import com.essntl.features.organization.ui.OrganizationScreen
import com.essntl.features.organization.ui.OrganizationState
import com.essntl.features.organization.ui.OrganizationValidation
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ContactDetailsDialog(
    isOpen: Boolean,
    onDismissRequest: () -> Unit,
    type : OrganizationModel.Type,
    contact: ContactModel?,
    organizationState: OrganizationState,
    organizationEvent: (OrganizationEvent) -> Unit,
    organizationValidation: OrganizationValidation,
    organizationAddressState: AddressState,
    organizationAddressEvent: (AddressEvent) -> Unit,
    organizationAddressValidation: AddressValidation,
    state: ContactState,
    onEvent: (ContactEvent) -> Unit,
    validation: ContactValidation,
    addressState: AddressState,
    onAddressEvent: (AddressEvent) -> Unit,
    addressValidation: AddressValidation,
    customFieldsState: CustomFieldsState,
    onCustomFieldsEvent: (CustomFieldsEvent) -> Unit,
    isSaveEnabled: Boolean,
    onEditTravelAgent: () -> Unit,
) {
    LaunchedEffect(isOpen) {
        if (isOpen) {
            contact?.let { c ->
                onEvent(
                    ContactEvent.GetContact(
                        c.id,
                    ),
                )

                onCustomFieldsEvent(
                    CustomFieldsEvent.SetType(
                        type = type,
                        contactId = c.id,
                    ),
                )

                onCustomFieldsEvent(
                    CustomFieldsEvent.GetTravelAgent(
                        contactId = c.id,
                    ),
                )
            }
        }
    }

    LaunchedEffect(state.getContact.isSuccess) {
        if (state.getContact.isSuccess) {
            state.getContact.data?.organization?.let { o ->
                organizationEvent(
                    OrganizationEvent.UpdateOrganizationFields(
                        organization = o,
                    ),
                )
            }

            val id = state.contact.value.address?.id
            if (id.isNullOrEmpty()) {
                onEvent(ContactEvent.AddRemoveAddress(false))
                onAddressEvent(AddressEvent.Clear)
            } else {
                onEvent(ContactEvent.AddRemoveAddress(true))
                onAddressEvent(
                    AddressEvent.GetAddress(
                        id = id,
                    ),
                )
            }
        }
    }

    LaunchedEffect(organizationState.organization.value.id) {
        onEvent(
            ContactEvent.UpdateContactFields(
                state.contact.value.copy(
                    organization = organizationState.organization.value,
                ),
            ),
        )
    }

    LaunchedEffect(
        customFieldsState.addEditTravelAgent.isSuccess,
        customFieldsState.addEditSupplier.isSuccess,
    ) {
        if (customFieldsState.addEditTravelAgent.isSuccess ||
            customFieldsState.addEditSupplier.isSuccess
        ) onEditTravelAgent()
    }

    if (isOpen)
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            properties = DialogProperties(
                usePlatformDefaultWidth = false,
            ),
            modifier = Modifier.fillMaxSize(0.7f),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = MaterialTheme.esColorScheme.bgPrimary)
                            .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = "Edit a travel agent",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    OrganizationScreen(
                        state = organizationState,
                        onEvent = organizationEvent,
                        validation = organizationValidation,
                        addressState = organizationAddressState,
                        onAddressEvent = organizationAddressEvent,
                        addressValidation = organizationAddressValidation,
                        creation = false,
                    )

                    Spacer(modifier = Modifier.height(1.spacing))

                    ContactDetailsScreen(
                        state = state,
                        onEvent = onEvent,
                        validation = validation,
                        addressState = addressState,
                        onAddressEvent = onAddressEvent,
                        addressValidation = addressValidation,
                        customFieldsState = customFieldsState,
                        onCustomFieldsEvent = onCustomFieldsEvent,
                        isSaveEnabled = isSaveEnabled,
                        onNavigation = {},
                    )
                }
            }
        }
}